import React, { createContext, ReactNode,useContext, useState } from 'react'

interface MobileSidebarContextType {
  isMobileSidebarOpen: boolean
  setIsMobileSidebarOpen: (isOpen: boolean) => void
}

const MobileSidebarContext = createContext<MobileSidebarContextType | undefined>(
  undefined
)

export function MobileSidebarProvider({ children }: { children: ReactNode }) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)

  return (
    <MobileSidebarContext.Provider
      value={{ isMobileSidebarOpen, setIsMobileSidebarOpen }}
    >
      {children}
    </MobileSidebarContext.Provider>
  )
}

export function useMobileSidebar() {
  const context = useContext(MobileSidebarContext)
  if (context === undefined) {
    // Return fallback values for SSR/SSG
    return {
      isMobileSidebarOpen: false,
      setIsMobileSidebarOpen: () => {}
    }
  }
  return context
}
